var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("UiButton", {
        class: _vm.customHover,
        attrs: {
          buttonText: "Resource request",
          label: "add black",
          buttonClass: "customAdd",
        },
        on: {
          click: function ($event) {
            _vm.modalShown = true
          },
        },
      }),
      _vm.modalShown
        ? _c("CustomRequestModal", {
            attrs: {
              currentUserId: _vm.currentUserId,
              companyId: _vm.companyId,
              skills: _vm.initialSkillIds,
              outerProcessing: _vm.processing,
              outerHandler: "",
            },
            on: {
              create: _vm.create,
              close: function ($event) {
                _vm.modalShown = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }